import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const JobResultItem = ({ job }) => {
  return (
    <Fragment>
      <div className="job-location-results">
        <Link to="/jobs">
          <div className="profile-drop-container">
            <i className="fas fa-search fa-lg drop-down-icon green"></i>
            <p className="drop-down-text">{job.jobtitle}</p>
          </div>
        </Link>
      </div>
    </Fragment>
  );
};

export default JobResultItem;
